export default __webpack_public_path__ + "static/media/IBimageKneestabilityatloadingresponse2.f2409a2d.png";